import { combineReducers } from 'redux';
import header from './header';
import lines from './lines';

export default combineReducers({ header, lines });

